import { Button, Flex, Notification, Text } from "orcs-design-system";

import { reloadApp, useAppUpdate } from "./useAppUpdate";

const AppUpdateNotice = () => {
  const updateReady = useAppUpdate();
  if (!updateReady) return null;

  return (
    <Notification
      floating
      centered
      bottom="xl"
      variant="informational"
      closable={false}
    >
      <Flex flexDirection="column" alignItems="center" gap="s">
        <Text textAlign="center">
          A new version is available. Reload to see the latest changes.
        </Text>
        <Button
          small
          variant="ghost"
          leftIcon={["fas", "sync"]}
          onClick={reloadApp}
        >
          Reload
        </Button>
      </Flex>
    </Notification>
  );
};

export default AppUpdateNotice;
